import {Icon, Label} from "semantic-ui-react";
import React, {useCallback} from "react";
import {useTypedSelector} from "../../../../../store/selectors/selectors.utils";
import {useDispatch} from "react-redux";
import {SearchActions} from "../../../../../store/actions/search.actions";
import styles from '../SearchBar.module.scss';
import {usePendingProjectMemberListSelector} from "../../../../../store/selectors/team.selectors";

export const ChipsList = () => {
    const searchParam = useTypedSelector(state => state.search.parameters);
    const memberList = useTypedSelector(state => state.team.memberList);
    const pendingMembers = usePendingProjectMemberListSelector()
    const allMembers = [...memberList, ...pendingMembers]
    const user = useTypedSelector(state => state.authorization.user);
    const dispatch = useDispatch();

    const removeChip = useCallback((text: string, type: string) => {
        if (type === 'owner') {
            dispatch(SearchActions.setTaskOwnerFilter([]));
            return;
        } else if (allMembers.some(el => el.userEmail === text)) {
            const el: any = allMembers.find((el: any) => el.userEmail === text);
            if (el) {
                dispatch(SearchActions.removeIdFromTaskforecFilter([el.userId ? el.userId : el.userEmail]));
            }
            return;
        }
        dispatch(SearchActions.removeChip(text));
    }, [dispatch, memberList, pendingMembers]);


    const Chip = useCallback(chip => (
        <Label className={styles.ActiveFilterChip}>
            {`${chip.type === 'owner' ? 'Owned by ' : ''}` + chip.text}
            <Icon name='delete' onClick={() => removeChip(chip.text, chip.type)}/>
        </Label>
    ), [removeChip]);

    if (!user) {
        return null;
    }

    return (
        <div className="search-bar-chips-wrap">
            {
                searchParam.chipList.map((chip) =>
                    <Chip key={chip.text} {...chip}/>
                )
            }
            {
                allMembers
                    .filter((el: any) =>
                        searchParam.taskForces.some(taskForce => taskForce && (
                            (el.userId && taskForce[0] === el.userId && taskForce[0] !== user.userId) ||
                            (taskForce[1] === el.userEmail && taskForce[1] !== user.userEmail))))
                    .map((el: any) =>
                        <Chip type='filter' text={el.userEmail} key={el.userId || el.userEmail}/>
                    )
            }
            {
                allMembers
                    .filter((el: any) =>
                        (el.userId && searchParam.taskOwner[0] === el.userId && searchParam.taskOwner[0] !== user.userId) ||
                        (searchParam.taskOwner[1] === el.userEmail && searchParam.taskOwner[1] !== user.userEmail)
                    )
                    .map((el: any) =>
                        <Chip type='owner' text={el.userEmail} key={el.userId}/>
                    )
            }
        </div>
    );
};
